import { useEffect } from "react";
import HeroSection from "../components/sections/HeroSection";
import JourneySection from "../components/sections/JourneySection";
import Footer from "../components/layout/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "Romaya AI Trip Planner";
  }, []);

  return (
    <main>
      <HeroSection />
      <JourneySection />
      <Footer />
    </main>
  );
}
